import React, { useEffect, useState, useRef } from 'react';
import TextField from '@material-ui/core/TextField';
import Dialog from '@mui/material/Dialog';
import { Stack } from '@mui/material';
import LevelButtonGroup from './LevelButtonGroup';

function Level1CodeDialog({
  okCallback,
  updateCallback,
  deleteCallback,
  cancelCallback,
  visible,
  newCode,
  defaultDescription,
  updateLevel1,
}) {
  const [description, setDescription] = useState(defaultDescription);
  const descriptionRef = useRef(null);

  // const level1Code = newCode;
  const [level1Code,setLevel1Code]=useState(newCode)

  const handleDescription = event => {
    setDescription(event.target.value);
  };

  const handlel1Change = (event) => {
    setLevel1Code(event.target.value);
  };

  const handleAdd = () => {
    if (description == '') {
      alert('Please enter all fields.');
    } else {
      const data = {
        code: level1Code,
        Discription: description,
      };
      okCallback(data);
    }
  };

  const handleCancel = () => {
    cancelCallback();
  };
  const handleUpdate = () => {
    const data = {
      code: level1Code,
      Discription: description,
    };
    updateCallback(data);
  };
  const handleDelete = () => {
    const data = {
      code: level1Code,
      Discription: description,
    };
    deleteCallback(data);
  };

  return (
    <Dialog open={visible} onClose={cancelCallback}>
      <Stack
        style={{
          minWidth: '40vw',
          height: '50vh',
          padding: '2rem',
        }}
        alignItems="center"
      >
        <TextField
          onChange={handlel1Change}
          style={{ width: '90%' }}
          id="l1code"
          label="Level 1 code"
          value={level1Code}
          disabled={updateLevel1}
          InputProps={{
            disableUnderline: false,
            margin: 'dense',
            // readOnly: true,
          }}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          onChange={handleDescription}
          style={{ width: '90%' }}
          required
          inputRef={descriptionRef}
          value={description}
          id="outlined-required"
          label="Description"
        />

        <LevelButtonGroup
          updateLevel={updateLevel1}
          handleUpdate={handleUpdate}
          handleDelete={handleDelete}
          handleCancel={handleCancel}
          handleAdd={handleAdd}
        />
      </Stack>
    </Dialog>
  );
}

export default Level1CodeDialog;
